import { ApiBind, Common } from './common.model';

export class AuthMFA extends Common {
  @ApiBind({ column: 'user_code' })
  mfaCode: string;

}
